export enum PlayButtonState {
  SHOW_BUFFERING = 'SHOW_BUFFERING',
  SHOW_PAUSE = 'SHOW_PAUSE',
  SHOW_PLAY = 'SHOW_PLAY',
  SHOW_RESTART = 'SHOW_RESTART'
}
